import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";

const StyledContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${hexToRGBA('#000000', 0.1)};
  border-radius: 0.25rem;

  label[for='legalName'] {
    width: 100%;
  }
`;

const StyledRow = styled(Row)`
  padding: 16px;
`;

function NonProfitOrgInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Non-profit Organization</span>
      </div>
      <StyledRow>
        <Col xs={12} md={6}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.legalName)}
            label="Legal Name of the Non-profit Organization"
            defaultInvalidMessage="Please provide a valid organization name"
            value={values[FORM_FIELD_KEYS.legalName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={6}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.dbaname)}
            label={getFieldProps(FORM_FIELD_KEYS.dbaname)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.dbaname]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.nonProfitType)}
            label={getFieldProps(FORM_FIELD_KEYS.nonProfitType)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.nonProfitType]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default NonProfitOrgInfoBlock;
